var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgELearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.679,2.63A4.214,4.214,0,0,0,18.328.878,4.3,4.3,0,0,0,14.545.161l-1.6.448a3.368,3.368,0,0,0-.943.43,3.375,3.375,0,0,0-.942-.43L9.454.161A4.3,4.3,0,0,0,5.672.878,4.214,4.214,0,0,0,4.321,2.63,5.509,5.509,0,0,0,0,8v5.5A5.507,5.507,0,0,0,5.5,19h5v2h-2a1.5,1.5,0,0,0,0,3h7a1.5,1.5,0,0,0,0-3h-2V19h5A5.507,5.507,0,0,0,24,13.5V8A5.509,5.509,0,0,0,19.679,2.63ZM13.5,3.8a.328.328,0,0,1,.251-.3l1.6-.448A1.4,1.4,0,0,1,15.719,3a1.311,1.311,0,0,1,.8.269,1.191,1.191,0,0,1,.485.96V7.807a1.241,1.241,0,0,1-.925,1.176L13.5,9.7ZM7.485,3.268A1.311,1.311,0,0,1,8.281,3a1.391,1.391,0,0,1,.365.051l1.6.448a.328.328,0,0,1,.25.3V9.7L7.924,8.983A1.241,1.241,0,0,1,7,7.807V4.228A1.191,1.191,0,0,1,7.485,3.268ZM21,13.5A2.5,2.5,0,0,1,18.5,16H5.5A2.5,2.5,0,0,1,3,13.5V8A2.489,2.489,0,0,1,4,6.012v1.8a4.25,4.25,0,0,0,3.116,4.065l3.2.9a6.251,6.251,0,0,0,3.36,0l3.2-.9A4.25,4.25,0,0,0,20,7.807v-1.8A2.489,2.489,0,0,1,21,8Z",
    fill: "rgba(100,21,255,1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgELearning);
export default __webpack_public_path__ + "static/media/e-learning.20d082c4306069321d7743f3c91cb533.svg";
export { ForwardRef as ReactComponent };